var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOnlinePresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.07,
    x2: 317.354,
    xlinkHref: "#lg1",
    y1: 110.869,
    y2: 360.622
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.416,
    x2: 337.64,
    y1: 104.064,
    y2: 298.288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.882,
    x2: 106.878,
    y1: 416.451,
    y2: 268.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0977,
    stopColor: "#bcd8de",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#a0c0ca",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#8cafbc",
    stopOpacity: 0.548
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7734,
    stopColor: "#80a5b4",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 362.568,
    y2: 421.334
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 402.472,
    y2: 426.272
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 407.161,
    y2: 390.645
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 331.093,
    y2: 382.513
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.167,
    x2: 185.5,
    xlinkHref: "#lg2",
    y1: 148.667,
    y2: 148.667
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.833,
    x2: 341.5,
    xlinkHref: "#lg2",
    y1: 133.333,
    y2: 133.333
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.833,
    x2: 378.833,
    xlinkHref: "#lg2",
    y1: 197.333,
    y2: 197.333
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.318,
    x2: 298.757,
    xlinkHref: "#lg3",
    y1: 170.891,
    y2: 281.33
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.445,
    x2: 192.144,
    y1: 308.888,
    y2: 261.587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268b4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.024,
    x2: 285.936,
    xlinkHref: "#lg4",
    y1: 154.77,
    y2: 187.681
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.813,
    x2: 330.007,
    xlinkHref: "#lg5",
    y1: 222.019,
    y2: 272.213
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 276,
    x2: 253.977,
    y1: 173.998,
    y2: 173.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41926"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.5,
    x2: 254.994,
    y1: 246.815,
    y2: 246.815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.216,
    x2: 149.883,
    y1: 273.864,
    y2: 337.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.021,
    x2: 131.44,
    xlinkHref: "#lg3",
    y1: 325.772,
    y2: 352.607
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.337,
    x2: 108.531,
    xlinkHref: "#lg5",
    y1: 282.269,
    y2: 293.664
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.256,
    x2: 162.617,
    xlinkHref: "#lg5",
    y1: 277.741,
    y2: 298.102
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.693,
    x2: 110.399,
    xlinkHref: "#lg6",
    y1: 299.564,
    y2: 305.27
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.591,
    x2: 152.576,
    xlinkHref: "#lg6",
    y1: 298.48,
    y2: 306.465
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.731,
    x2: 148.771,
    xlinkHref: "#lg6",
    y1: 302.982,
    y2: 302.982
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.453,
    x2: 136.049,
    xlinkHref: "#lg4",
    y1: 318.153,
    y2: 318.153
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.5,
    x2: 123.165,
    xlinkHref: "#lg1",
    y1: 301.754,
    y2: 301.754
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.337,
    x2: 140.002,
    xlinkHref: "#lg1",
    y1: 301.754,
    y2: 301.754
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.251,
    x2: 128.251,
    y1: 304.409,
    y2: 310.377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.681,
    x2: 121.896,
    xlinkHref: "#lg5",
    y1: 283.729,
    y2: 296.945
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.942,
    x2: 145.321,
    xlinkHref: "#lg5",
    y1: 276.464,
    y2: 296.842
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.295,
    x2: 128.295,
    y1: 251,
    y2: 259.667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef5f6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456.744 71.883h-403.488c-8.838 0-16.003 7.165-16.003 16.003v271.528h435.494v-271.528c0-8.838-7.165-16.003-16.003-16.003z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.741 87.274h-371.482c-8.887 0-16.091 7.204-16.091 16.091v224.568c0 8.887 7.204 16.091 16.091 16.091h371.482c8.887 0 16.091-7.204 16.091-16.091v-224.569c-.001-8.886-7.205-16.09-16.091-16.09z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.259 344.023h232.15l-93.239-93.239c-.502-1.887-2.206-3.284-4.251-3.284h-145.168c-2.439 0-4.416 1.977-4.416 4.416v77.187c0 4.148 1.579 7.915 4.157 10.763 2.854 2.575 6.621 4.157 10.767 4.157z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m469.851 357.321h-429.702c-4.273 0-8.253 2.172-10.566 5.765l-24.871 38.643c-1.657 2.575.191 5.963 3.253 5.963h494.069c3.062 0 4.91-3.388 3.253-5.963l-24.871-38.643c-2.312-3.593-6.292-5.765-10.565-5.765z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.259 438.117h-478.518c-8.694 0-15.741-7.047-15.741-15.74v-9.444c0-8.693 7.047-15.741 15.741-15.741h478.518c8.693 0 15.741 7.047 15.741 15.741v9.444c0 8.693-7.047 15.74-15.741 15.74z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.815 387.048h50.37c5.216 0 9.444 4.228 9.444 9.444 0 5.216-4.228 9.444-9.444 9.444h-50.37c-5.216 0-9.444-4.228-9.444-9.444-.001-5.216 4.228-9.444 9.444-9.444z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.184 375.81-10.401-18.489h-387.566l-10.401 18.489c-1.947 3.462.554 7.739 4.526 7.739h399.316c3.972 0 6.474-4.277 4.526-7.739z",
    fill: "url(#SVGID_7_)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m180 168.167c-1.407 0-2.815-.537-3.889-1.611l-25.058-25.058c-.859-.858-2.001-1.331-3.216-1.331h-25.171c-3.037 0-5.5-2.463-5.5-5.5s2.463-5.5 5.5-5.5h25.171c4.153 0 8.058 1.617 10.993 4.554l25.058 25.058c2.148 2.147 2.148 5.63 0 7.777-1.073 1.074-2.481 1.611-3.888 1.611z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.333 150.833c-1.407 0-2.815-.537-3.889-1.611-2.148-2.147-2.148-5.63 0-7.777l24-24c1.031-1.032 2.43-1.611 3.889-1.611h28.667c3.037 0 5.5 2.463 5.5 5.5s-2.463 5.5-5.5 5.5h-26.389l-22.39 22.389c-1.073 1.073-2.481 1.61-3.888 1.61z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.333 202.833h-42c-3.037 0-5.5-2.463-5.5-5.5s2.463-5.5 5.5-5.5h42c3.037 0 5.5 2.463 5.5 5.5s-2.463 5.5-5.5 5.5z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 305.671c0 3.612-3.052 6.497-6.655 6.252-50.191-3.419-89.845-45.216-89.845-96.274s39.654-92.855 89.845-96.274c3.603-.245 6.655 2.64 6.655 6.252z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.345 311.922c3.603.245 6.655-2.64 6.655-6.252v-8.057l-46.829-46.829c-.502-1.887-2.206-3.284-4.251-3.284h-40.039c12.459 35.646 45.244 61.751 84.464 64.422z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 132.347v83.301l58.902-58.902c-15.074-15.075-35.899-24.399-58.902-24.399z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.927 156.721-58.927 58.927v89.833c49.614 0 89.833-40.22 89.833-89.833 0-22.401-8.199-42.887-21.76-58.62-2.366-2.745-6.583-2.87-9.146-.307z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.5 137.016c-8.612-3.012-17.86-4.668-27.5-4.668v83.301l27.5-27.5z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.5 188.148-27.5 27.5v89.833c9.593 0 18.832-1.51 27.5-4.294z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.142 273.842h-70.618c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h70.618c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.142 296.528h-70.618c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h70.618c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.284 319.213h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m424.951 204.546h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.38 128.102h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.047 141.436h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.169 258.667v69.269c0 8.888 7.199 16.087 16.087 16.087h134.077v-85.356z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.469 344.023c0-11.333 9.187-20.52 20.52-20.52h10.523c11.333 0 20.52 9.187 20.52 20.52z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.77 273c-8.236-.156-14.978 6.784-14.978 15.022v8.815c0 3.064 2.484 5.548 5.548 5.548 3.064 0 5.548-2.484 5.548-5.548v-3.34c0-4.925 3.785-9.162 8.704-9.394 5.252-.247 9.588 3.938 9.588 9.136v-5.548c0-8.02-6.426-14.54-14.41-14.691z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.732 273c8.236-.156 14.978 6.784 14.978 15.022v8.815c0 3.064-2.484 5.548-5.548 5.548-3.064 0-5.548-2.484-5.548-5.548v-3.34c0-4.925-3.785-9.162-8.704-9.394-5.252-.247-9.588 3.938-9.588 9.136v-5.548c0-8.02 6.426-14.54 14.41-14.691z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.605 302.631c0-3.355 2.329-6.166 5.458-6.905.836-.197 1.636.449 1.636 1.309v11.191c0 .859-.8 1.506-1.636 1.309-3.129-.738-5.458-3.549-5.458-6.904z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.897 302.631c0-3.355-2.329-6.166-5.458-6.905-.836-.197-1.636.449-1.636 1.309v11.191c0 .859.8 1.506 1.636 1.309 3.129-.738 5.458-3.549 5.458-6.904z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m128.251 328.764c-11.333 0-20.52-9.187-20.52-20.52v-10.524c0-11.333 9.187-20.52 20.52-20.52 11.333 0 20.52 9.187 20.52 20.52v10.523c0 11.334-9.187 20.521-20.52 20.521z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.251 322.138c-3.77 0-6.928-2.617-7.758-6.133-.222-.94.505-1.838 1.471-1.838h12.575c.966 0 1.692.898 1.471 1.838-.831 3.517-3.989 6.133-7.759 6.133z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.832 305.941c-1.84 0-3.332-1.492-3.332-3.332v-1.709c0-1.84 1.492-3.332 3.332-3.332 1.84 0 3.332 1.492 3.332 3.332v1.709c.001 1.84-1.491 3.332-3.332 3.332z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.67 305.941c-1.84 0-3.332-1.492-3.332-3.332v-1.709c0-1.84 1.492-3.332 3.332-3.332 1.84 0 3.332 1.492 3.332 3.332v1.709c0 1.84-1.492 3.332-3.332 3.332z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m129.385 310.787h-2.267c-1.89 0-3.32-1.707-2.989-3.568l1.3-7.306h5.646l1.3 7.306c.33 1.86-1.101 3.568-2.99 3.568z",
    fill: "url(#SVGID_27_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.69 284.372c0 7.538-6.111 13.649-13.649 13.649-4.013 0-6.929-3.879-5.745-7.713 1.355-4.389 3.836-8.283 7.106-11.346 4.655-4.362 12.288-.969 12.288 5.41z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.969 279.54c0-3.402 2.386-6.319 5.71-7.043 1.798-.392 3.665-.598 5.581-.598 11.719 0 21.636 7.717 24.946 18.347 1.201 3.857-1.688 7.775-5.728 7.775h-12.028c-10.206 0-18.481-8.274-18.481-18.481z",
    fill: "url(#SVGID_29_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m199.006 265.333h-141.422c-2.439 0-4.416-1.977-4.416-4.416v-10.169c0-2.439 1.977-4.416 4.416-4.416h141.421c2.439 0 4.416 1.977 4.416 4.416v10.169c0 2.439-1.976 4.416-4.415 4.416z",
    fill: "url(#SVGID_30_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnlinePresentation);
export default __webpack_public_path__ + "static/media/icon-online-presentation.c5abcfd019ebe3d3abd735c06fd0bf96.svg";
export { ForwardRef as ReactComponent };